(() => {
  if (customElements.get('slider-gallery')) {
    return;
  }

  class SliderGallery extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 15,
        loop: true,
        freeMode: true,
        breakpoints: {
          990: {
            centeredSlides: true,
            spaceBetween: parseInt(this.getAttribute('data-spacing')) || 40,
          },
        },
      };
      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
          pauseOnMouseEnter: true,
        };
      }
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('slider-gallery', SliderGallery);
})();
